import api from './../utils/api';


export const getAllUsersForAdmin = async (limit, page, search = "", sort = false) => {
  try {
    const query = encodeURIComponent(search);
    const response = await api.get(`/user/all-users?limit=${limit}&page=${page}&search=${query}&sort=${sort}`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleBanUserForAdmin = async (userId, isBanned) => {
  try {
    const response = await api.patch(`/user/toggle-ban/${userId}`,
      {
      isBanned
    },
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUser = async (userId) => {
  try {
    const response = await api.get(`/user/get-user/${userId}`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changePassword = async (currentPassword, newPassword, confirmNewPassword) => {
  try {
    const response = await api.post(`/user/change-password`, {
      currentPassword,
      newPassword,
      confirmNewPassword
    },
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateInformation = async (username, fullName, phone) => {
  try {
    const response = await api.patch(`/user/update-information`, {
      username,
      fullName,
      phone
    },
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEmployees = async () => {
  try {
    const response = await api.get(`/user/employees`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createNewEmployee = async (type) => {
  try {
    const response = await api.post(`/user/create-employee`,
    {type},
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserTotalDeposit = async () => {
  try {
    const response = await api.get(`/user/get-total-deposit`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserForAdmin = async (userId, userData) => {
  try {
    const response = await api.put(`/user/update-user/${userId}`,
      {
        fullName: userData.fullName,
        email: userData.email,
        newPassword: userData.newPassword
    },
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const modifyUserBalanceForAdmin = async (userId, modify_type, amount, reason) => {
  try {
    const response = await api.patch(`/user/modify-balance/${userId}`,
      {
        modify_type,
        amount,
        reason
    },
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserForAdmin = async (userId) => {
  try {
    const response = await api.delete(`/user/delete-user/${userId}`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
